import React from "react";

interface ErrorComponentProps {
  message: string;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ message }) => {
  return (
    <div className="flex justify-center items-center">
      <div className="bg-red-600 dark:bg-red-700 text-white px-4 py-2 rounded-lg shadow-lg">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ErrorComponent;
